export default function TeamCrest({ team, size = "md", testid }) {
    const sizes = {
        xs: "w-7 h-7 text-[10px] rounded-md",
        sm: "w-9 h-9 text-xs rounded-lg",
        md: "w-12 h-12 text-base rounded-xl",
        lg: "w-20 h-20 text-2xl rounded-2xl",
        xl: "w-20 h-20 text-2xl rounded-2xl sm:w-28 sm:h-28 sm:text-4xl sm:rounded-3xl",
    };
    const label = (team?.short_name || team?.name?.slice(0, 3) || "YKP").toUpperCase();
    const color = team?.primary_color || "#FF5500";
    if (team?.logo) {
        return (
            <div
                data-testid={testid}
                className={`${sizes[size]} flex items-center justify-center shrink-0 overflow-hidden`}
                style={{
                    background: `linear-gradient(135deg, ${color}14, transparent)`,
                    border: `1.5px solid ${color}80`,
                }}
            >
                <img src={team.logo} alt={team.name || "Team logo"} className="w-full h-full object-contain p-0.5" />
            </div>
        );
    }
    return (
        <div
            data-testid={testid}
            className={`${sizes[size]} flex items-center justify-center font-display font-black tracking-wider shrink-0`}
            style={{
                background: `linear-gradient(135deg, ${color}2b, ${color}0d)`,
                border: `1.5px solid ${color}80`,
                color,
                textShadow: `0 0 18px ${color}90`,
            }}
        >
            {label}
        </div>
    );
}
